module.exports = __webpack_public_path__ + "img/keres.fa18d0b3.png";